import React, { useEffect } from "react";
import Footer from "../components/Footer/Footer";
import { useTranslation } from "react-i18next";
import { FaBuilding, FaMapMarkerAlt, FaUserTie } from "react-icons/fa";

const AboutUs = () => {
	const { t } = useTranslation();

	useEffect(() => {
		window.scrollTo({
			top: 0,
			left: 0,
			behavior: "smooth",
		});
	}, []);

	return (
		<>
			<section className="min-h-screen bg-gradient-to-b from-cream to-warm dark:from-slate-900 dark:to-slate-800 dark:text-white py-16 relative overflow-hidden">
				{/* Background decorations */}
				<div className="absolute top-20 left-10 w-72 h-72 bg-accent/10 rounded-full blur-3xl"></div>
				<div className="absolute bottom-40 right-10 w-96 h-96 bg-slate-400/10 rounded-full blur-3xl"></div>

				<div className="container mx-auto px-6 relative z-10">
					{/* Header */}
					<div className="text-center mb-16 animate-fade-in-down">
						<span className="text-accent font-semibold text-sm tracking-wider">
							{t("about.welcome")}
						</span>
						<h1 className="section-title mt-3">
							<span className="gradient-text">{t("aboutUs.title")}</span>
						</h1>
					</div>

					{/* Main Content Card */}
					<div className="max-w-5xl mx-auto">
						{/* Office Section */}
						<div className="mb-16 animate-fade-in-up">
							<div className="bg-white dark:bg-slate-800 rounded-3xl shadow-card overflow-hidden border border-gray-100 dark:border-slate-700">
								<div className="p-8 md:p-10">
									<div className="flex items-center gap-4 mb-6">
										<div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-slate-700 to-slate-500 flex items-center justify-center shadow-lg">
											<FaBuilding className="text-white text-2xl" />
										</div>
										<h2 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white">
											{t("aboutUs.officeSection.title")}
										</h2>
									</div>
									<p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-8">
										{t("aboutUs.officeSection.description")}
									</p>
								</div>
								<div className="flex justify-center p-6 pt-0">
									<img
										src="https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/uqiyueqd4odekrzl4de6"
										alt={t("aboutUs.officeSection.imageAlt")}
										className="max-h-[850px] w-auto rounded-2xl shadow-lg"
									/>
								</div>
							</div>
						</div>

						{/* Location Section */}
						<div className="mb-16 animate-fade-in-up animate-delay-200">
							<div className="bg-white dark:bg-slate-800 rounded-3xl shadow-card overflow-hidden border border-gray-100 dark:border-slate-700">
								<div className="p-8 md:p-10">
									<div className="flex items-center gap-4 mb-6">
										<div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-accent to-orange-400 flex items-center justify-center shadow-lg">
											<FaMapMarkerAlt className="text-white text-2xl" />
										</div>
										<h2 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white">
											{t("aboutUs.locationSection.title")}
										</h2>
									</div>
									<p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-8">
										{t("aboutUs.locationSection.description")}
									</p>
								</div>
								<div className="relative h-[450px]">
									<iframe
										title={t("aboutUs.locationSection.mapTitle")}
										src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3147.673525164171!2d28.215285776146898!3d36.437813680026885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x149520aa35c1e39d%3A0x3a0d9aaf14f4ea2d!2sKodrigktonos%2049%2C%20Rodos%2085100%2C%20Greece!5e0!3m2!1sen!2sus!4v1696767722720!5m2!1sen!2sus"
										width="100%"
										height="100%"
										allowFullScreen=""
										loading="lazy"
										referrerPolicy="no-referrer-when-downgrade"
										className="absolute inset-0"
									></iframe>
								</div>
							</div>
						</div>

						{/* Founder Section */}
						<div className="animate-fade-in-up animate-delay-300">
							<div className="bg-white dark:bg-slate-800 rounded-3xl shadow-card overflow-hidden border border-gray-100 dark:border-slate-700">
								<div className="p-8 md:p-10">
									<div className="flex items-center gap-4 mb-6">
										<div className="w-14 h-14 rounded-2xl bg-gradient-to-br from-slate-600 to-slate-400 flex items-center justify-center shadow-lg">
											<FaUserTie className="text-white text-2xl" />
										</div>
										<h2 className="text-2xl md:text-3xl font-bold text-slate-800 dark:text-white">
											{t("aboutUs.founderSection.title")}
										</h2>
									</div>
									<p className="text-gray-600 dark:text-gray-300 text-lg leading-relaxed mb-8">
										{t("aboutUs.founderSection.description")}
									</p>
								</div>
								<div className="flex justify-center p-6 pt-0">
									<img
										src="https://res.cloudinary.com/dmwvkjqsn/image/upload/f_auto,q_auto/v1/AccountingBusinessCDN/st8dstbjgwzt7iomopjl"
										alt={t("aboutUs.founderSection.imageAlt")}
										className="max-h-[600px] w-auto rounded-2xl shadow-lg"
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
			</section>
			<Footer />
		</>
	);
};

export default AboutUs;
